var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-alert',{attrs:{"show":typeof _vm.errors === 'string',"variant":"danger","fade":""}},[_vm._v(" "+_vm._s(_vm.errors)+" ")]),(typeof _vm.errors == 'object')?_vm._l((_vm.errors),function(error,i){return _c('b-alert',{key:i,attrs:{"show":Boolean(i),"variant":"danger","fade":""}},[_vm._v(" "+_vm._s(error[0])+" ")])}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }